import React from "react";
import { BrowserRouter } from "react-router-dom";
import { GlobalStyle }  from "./styles/global";
import Routes from "./routes/routes";
import { clearCacheIfNewVersion } from './versionCheck';

const App = () => {
    clearCacheIfNewVersion();
    return(
        <BrowserRouter>
            <GlobalStyle />
            <Routes />
        </BrowserRouter>
    )
};
export default App;